import { TrackTypes } from './../../shared/service/journey/tracks/model/track-types';
import { Injectable } from '@angular/core';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { IncomeEquity } from '../../shared/service/update-registration/model/update-registration.model';

@Injectable({
  providedIn: 'root'
})
export class IncomeWealthService {

  private readonly STEP_CODE = 'income-equity';

  private defaultDataPrevious = {
    income: '',
    patrimony: '',
    taxResidence: '',
    taxResidenceName: '',
    nif: '',
    dateTaxResidency: '',
    noIncome: false,
    noPatrimony: false,
  }

  private initialDataTaxResidence = {
    taxResidence: '',
    taxResidenceName: '',
    dateTaxResidency: '',
    nif: '',
  }

  public dataIncomeWealthPrevious = { ...this.defaultDataPrevious }

  constructor(private journeyService: JourneyService) {
  }

  public setIncome(income: string, journey?: string, isEventComunicator?: boolean) {
    const incomeValue = income.replace('.', '').replace(',', '.').replace(/\D/g, '');
    const value = [incomeValue.slice(0, -2), '.', incomeValue.slice(-2)].join('');
    this.dataIncomeWealthPrevious.income = this.journeyService.registratioJourney.data.incomeEquity.income;
    this.journeyService.registratioJourney.data.incomeEquity.income = value;

    if (journey || isEventComunicator) {
      this.setIsCompleteStepData(journey, isEventComunicator);
    }

    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setPatrimony(patrimony: string, journey?: string, isEventComunicator?: boolean) {
    const patrimonyValue = patrimony.replace('.', '').replace(',', '.').replace(/\D/g, '');
    const value = [patrimonyValue.slice(0, -2), '.', patrimonyValue.slice(-2)].join('');
    this.dataIncomeWealthPrevious.patrimony = this.journeyService.registratioJourney.data.incomeEquity.patrimony;
    this.journeyService.registratioJourney.data.incomeEquity.patrimony = value;

    if (journey || isEventComunicator) {
      this.setIsCompleteStepData(journey, isEventComunicator);
    }

    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setTaxResidence(taxResidence: string) {
    this.dataIncomeWealthPrevious.taxResidence = this.journeyService.registratioJourney.data.incomeEquity.taxResidence;
    this.journeyService.registratioJourney.data.incomeEquity.taxResidence = taxResidence;
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setTaxResidenceName(taxResidenceName: string) {
    this.dataIncomeWealthPrevious.taxResidenceName = this.journeyService.registratioJourney.data.incomeEquity.taxResidenceName;
    this.journeyService.registratioJourney.data.incomeEquity.taxResidenceName = taxResidenceName;
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setNif(nif: string) {
    this.dataIncomeWealthPrevious.nif = this.journeyService.registratioJourney.data.incomeEquity.nif;
    this.journeyService.registratioJourney.data.incomeEquity.nif = nif;
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setDateTaxResidency(date: string) {
    this.dataIncomeWealthPrevious.dateTaxResidency = this.journeyService.registratioJourney.data.incomeEquity.dateTaxResidency;
    this.journeyService.registratioJourney.data.incomeEquity.dateTaxResidency = date;
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  public setCheckBoxIncome(check: boolean) {
    this.journeyService.registratioJourney.data.incomeEquity.noIncome = check;
  }

  public setCheckBoxPatrimony(check: boolean) {
    this.journeyService.registratioJourney.data.incomeEquity.noPatrimony = check;
  }

  public setPersonLinkedToTheBrokerage(check: boolean) {
    this.journeyService.registratioJourney.data.incomeEquity.personLinkedToTheBrokerage = check;
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.incomeEquity);
  }

  setIsCompleteStepData(journey: string, isEventComunicator: boolean) {
    this.journeyService.registratioJourney.data.incomeEquity.isCompleted = this.incomeDataIsComplete(journey, isEventComunicator);
  }

  incomeDataIsComplete(journey: string, isEventComunicator: boolean): boolean {
    const id: string = this.journeyService.registratioJourney.data.professionalData?.originIncome;
    const incomeRequired = this.journeyService.registratioJourney.data.professionalData.incomeRequired
    const patrimonyRequired = this.journeyService.registratioJourney.data.professionalData.patrimonyRequired;
    const idNoIncomeField = ['11842', '11841', '11834'];
    const idNeedPatrimonyField = ['11837', '11840', '11833'];

    if (journey === TrackTypes.BASIC) {
      if (idNoIncomeField.indexOf(id) === -1
        && (!this.journeyService.registratioJourney.data.incomeEquity.income ||
          this.valueInformedEmpty(this.journeyService.registratioJourney.data.incomeEquity.income))
      ) {
        return false;
      }
  
      if (idNeedPatrimonyField.indexOf(id) >= 0
        && (!this.journeyService.registratioJourney.data.incomeEquity.patrimony ||
          this.valueInformedEmpty(this.journeyService.registratioJourney.data.incomeEquity.patrimony))
      ) {
        return false;
      }
    }

    if (!isEventComunicator) {
      if (incomeRequired && (!this.journeyService.registratioJourney.data.incomeEquity.income ||
          this.valueInformedEmpty(this.journeyService.registratioJourney.data.incomeEquity.income))
      ) {
        return false;
      }

      if (patrimonyRequired && (!this.journeyService.registratioJourney.data.incomeEquity.patrimony ||
          this.valueInformedEmpty(this.journeyService.registratioJourney.data.incomeEquity.patrimony))
      ) {
        return false;
      }
    }


    return true;
  }

  valueInformedEmpty(val: any) {
    if ( val === '0,00' || val === '0' || val === '') {
      return true
    }

    return false;
  }

  setDataIncomeWealthPrevious(data: { [key: string]: string | boolean }) {
    for(var key in data) {
      if(data[key] !== "") {
        this.setDataIncomeWealth(key, data[key]);
      }
    }
  }

  resetDataIncomeWealthPrevious() {
    this.dataIncomeWealthPrevious = { ...this.defaultDataPrevious }
  }

  setDataIncomeWealth(prop: string, value: string | boolean) {
    this.journeyService.registratioJourney.data.incomeEquity[prop] = value;
  }

  resetDataIncomeWealth() {
    const dataPrevious = this.dataIncomeWealthPrevious;
    this.resetDataIncomeWealthPrevious();
    this.setDataIncomeWealthPrevious(dataPrevious);
  }

  setInitialDataTaxResidence(data: IncomeEquity) {
    if (this.initialDataTaxResidence.taxResidence === '') {
      this.initialDataTaxResidence = {
        taxResidence: data.taxResidence,
        taxResidenceName: data.taxResidenceName,
        dateTaxResidency: data.dateTaxResidency,
        nif: data.nif,
      };
    }
  }

  getInitialDataTaxResidence() {
    return this.initialDataTaxResidence;
  }
}
